import { publicEnv } from '~/features/environment/public';
import { queryUdacityService } from '~/utils/query-udacity-service';

import { UserPurchaseStats, userPurchaseStatsSchema } from '../models/user-purchase-stats';

// Get a user's Braavos data
export async function getUserPurchaseStats({
  jwt,
  userId,
}: {
  jwt: string;
  userId: string;
}): Promise<UserPurchaseStats> {
  return await queryUdacityService({
    url: `${publicEnv.NEXT_PUBLIC_BRAAVOS_URL}/users/${userId}`,
    zodSchema: userPurchaseStatsSchema,
    authorization: `Bearer ${jwt}`,
    method: 'GET',
  });
}
